import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Bewijsstuk, Knop } from '@app/core/interfaces/bewijsstukken';
import { NewModal, Notification } from 'outshared-lib';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation.modal';

@Component({
    selector: 'ins-paperwork',
    templateUrl: './paperwork.component.html',
    styleUrls: ['./paperwork.component.scss'],
})
export class PaperworkComponent implements OnDestroy {
    @Output() readonly submitEvidence = new EventEmitter<{
        dossier_volgnummer: number,
        upload_enveloppe_volgnummer: number,
    }>();

    @Input() dossier_volgnummer: number;
    @Input() relatie_id: number;
    @Input() documentaryEvidence: Bewijsstuk[];
    @Input() selectedButtons: Knop[];
    @Input() upload_enveloppe_volgnummer: number;
    @Input() messages: Notification[];
    @Input() isLoading: boolean;
    @Input() isLoaded: boolean;
    @Input() buttonSubmit: Knop;
    private subscriptions: Subscription = new Subscription();

    constructor(
        private newModal: NewModal,
    ) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public onSubmit(): void {
        const modalRef = this.newModal.open(ConfirmationModalComponent);

        modalRef.componentInstance.model = {
            title: 'Weet u het zeker?',
            body: 'Heeft u echt alles toegevoegd? Zo niet, upload eerst alle stukken voordat u het indient.',
            bevestiging: 'Bevestigen',
            ontkenning: 'Annuleren',
        };

        const modalSubscription = modalRef
            .afterClosed$()
            .pipe(tap((res) => {
                this.submitDocumentaryEvidence();
            }))
            .subscribe();

        this.subscriptions.add(modalSubscription);
        this.buttonSubmit = {
            ...this.buttonSubmit,
            knop_status: 'hidden',
        };
        this.messages = [];
    }

    private submitDocumentaryEvidence(): void {
        this.submitEvidence.emit({
            dossier_volgnummer: this.dossier_volgnummer,
            upload_enveloppe_volgnummer: this.upload_enveloppe_volgnummer,
        });
    }
}
